import { render } from "./UI2Layout.vue?vue&type=template&id=aef2040a"
const script = {}

import "./UI2Layout.vue?vue&type=style&index=0&id=aef2040a&lang=scss"

import exportComponent from "D:\\phpEnv\\www\\zy\\frontend\\zhiyadu\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__